import { formatApiError } from "../utils/apiErrors";
import { isDefaultMaintenanceMessage, maintenanceNotice } from "./maintenanceMessages";

// Native confirmations and asynchronous errors cannot rely on DOM translation.
export function projectErrorMessage(error, isGreek) {
  const message = formatApiError(error);
  if (isDefaultMaintenanceMessage(message)) return maintenanceNotice(isGreek);
  if (!isGreek || /^[Α-Ωα-ωΆ-Ώά-ώ]/.test(message)) return message;
  if (error?.status === 409 && !/same name|already exists/i.test(message)) {
    return "Το έργο έχει αλλάξει από άλλη συνεδρία. Αποθηκεύστε τις αλλαγές σας με «Αποθήκευση ως» ή ανοίξτε ξανά το έργο.";
  }
  const rules = [
    [/same name|already exists/i, "Υπάρχει ήδη έργο με αυτό το όνομα. Επιλέξτε διαφορετικό όνομα."],
    [/conflict|modified|updated.*another|changed.*another|stale/i, "Το έργο έχει αλλάξει από άλλη συνεδρία. Αποθηκεύστε τις αλλαγές σας με «Αποθήκευση ως» ή ανοίξτε ξανά το έργο."],
    [/not found|404/i, "Το έργο δεν βρέθηκε. Ίσως έχει ήδη διαγραφεί."],
    [/demo.*expired/i, "Η δοκιμαστική περίοδος έχει λήξει."],
    [/project.*limit/i, "Έχετε φτάσει το όριο έργων του δοκιμαστικού λογαριασμού."],
    [/account.*locked/i, "Ο λογαριασμός είναι κλειδωμένος."],
    [/not authorized|unauthorized|not authenticated|forbidden/i, "Δεν έχετε δικαίωμα για αυτή την ενέργεια. Ελέγξτε ότι είστε συνδεδεμένοι."],
    [/rate limit|too many requests/i, "Έγιναν πάρα πολλά αιτήματα. Περιμένετε λίγο και δοκιμάστε ξανά."],
    [/server could not be reached|failed to fetch|network|load failed/i, "Δεν ήταν δυνατή η σύνδεση με τον διακομιστή. Δοκιμάστε ξανά."],
    [/required parameters/i, "Λείπουν υποχρεωτικές παράμετροι."],
  ];
  for (const [pattern, translation] of rules) {
    if (pattern.test(message)) return translation;
  }
  // Retain unexpected server details for diagnosis, with a localized explanation.
  return `Δεν ήταν δυνατή η ολοκλήρωση της ενέργειας στο έργο. Λεπτομέρειες: ${message}`;
}
